import { Box } from '@mui/material';
import styled from 'styled-components';
export const PointerBox = styled(Box) `
  && {
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  }
`;
export default PointerBox;
